<template>
  <div id="ticket">
    <loading v-if="isShowLoading"></loading>
    <div class="ticket_wrap">
      <div class="title">
        <Row v-if="!islogin">
          <Col span="24" @click="toggle_tick">
            <img src="../../assets/mp.png" alt="景区门票"
          /></Col>
        </Row>
        <Row v-else class="ivuRow">
          <Col span="12">
            <div
              :style="{ textAlign: 'right', cursor: 'pointer' }"
              @click="toggle_tick"
              v-if="isShow.ticketCard"
            >
              <img src="../../assets/tick_tickhover.png" alt="景区门票" />
            </div>
            <div
              :style="{ textAlign: 'right', cursor: 'pointer' }"
              @click="toggle_tick"
              v-else
            >
              <img src="../../assets/tick_tick.png" alt="景区门票" />
            </div>
          </Col>
          <Col span="12">
            <div
              :style="{ textAlign: 'left', cursor: 'pointer' }"
              @click="toggle_travel"
              v-if="isShow.travelCard"
            >
              <img src="../../assets/tick_cardhover.png" alt="旅游卡专享" />
            </div>
            <div
              :style="{ textAlign: 'left', cursor: 'pointer' }"
              @click="toggle_travel"
              v-else
            >
              <img src="../../assets/tick_card.png" alt="旅游卡专享" />
            </div>
          </Col>
        </Row>
      </div>
      <div class="dsj"></div>
      <!-- 景区门票 -->
      <transition name="fade-tick">
        <div class="tickets" v-if="isShow.ticketCard">
          <template v-if="!ticketList.length">
            <div class="img"></div>
            <div class="Word" v-if="keyWord">
              很遗憾,没有搜索到与"{{ keyWord }}"相关的内容请尝试搜索其他关键词
            </div>
            <div class="Word" v-else>暂无景区门票</div>
          </template>
          <template v-else>
            <dl v-for="(item, idx) in ticketList" :key="idx">
              <dt>
                <img
                  :src="
                    item.piclist && item.piclist.length > 0
                      ? item.piclist[0].upadder
                      : item.upadder
                  "
                  @click="buyNow(item.iscenicid)"
                  alt="图片加载失败"
                />
                <p>{{ item.strgrade }}</p>
              </dt>
              <dd>
                <h3 @click="buyNow(item.iscenicid)">{{ item.szscenicname }}</h3>
                <p>
                  <span class="sp3" v-if="item.price"
                    >¥<span :style="{ fontSize: '20px', margin: '0 5px' }">{{
                      item.price
                    }}</span
                    >起</span
                  >
                  <!-- <span class="sp3">¥<span :style="{fontSize:'20px',margin:'0 5px'}">{{ item.price ?item.price!='0.01'?item.price:'50.00':'30.00'}}</span>起</span> -->
                  <button @click="buyNow(item.iscenicid)">立即购买</button>
                </p>
              </dd>
            </dl>
            <div class="clearfix"></div>
          </template>

          <div class="fenye">
            <Page
              v-if="page.total > 0"
              :total="page.total"
              :current="page.page"
              :page-size="12"
              prev-text="上一页"
              next-text="下一页"
              @on-change="changePage"
            >
            </Page>
          </div>
        </div>
      </transition>
      <!-- 旅游卡专享 -->
      <transition name="fade-tick">
        <template v-if="!cardList.length && isShow.travelCard">
          <div class="tickets">
            <div class="img"></div>
            <div class="Word">暂无旅游卡专享门票</div>
          </div>
        </template>
        <template v-else>
          <div class="tickets" v-if="isShow.travelCard">
            <dl v-for="(item, idx) in cardList" :key="idx">
              <dt>
                <img
                  :src="item.UPADDER ? item.UPADDER : ''"
                  @click="buyNow(item.ISCENICID, 'lc')"
                  alt="图片加载失败"
                />
                <p>国家{{ rank[item.SZGRADE] }}级景区</p>
              </dt>
              <dd>
                <h3 @click="buyNow(item.ISCENICID, 'lc')">
                  {{ item.SZSCENICNAME }}
                </h3>
                <p>
                  <span class="sp3"
                    >¥<span :style="{ fontSize: '20px', margin: '0 5px' }"
                      >0.00</span
                    >元
                    <del
                      >原价：{{
                        item.LISTINGPRICE ? item.LISTINGPRICE : "0.00"
                      }}起</del
                    >
                  </span>
                  <button
                    @click="buyNow(item.ISCENICID, 'lc')"
                    :style="{ marginLeft: '15px' }"
                  >
                    立即购买
                  </button>
                </p>
              </dd>
            </dl>
            <div class="clearfix"></div>
          </div>
        </template>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "ticket",
  data: function () {
    return {
      isShowLoading: false,
      islogin: sessionStorage.getItem("name") ? true : false, //用户是否登录，有登录显示旅游卡购票
      fxsId: sessionStorage.getItem("fxsId")
        ? sessionStorage.getItem("fxsId")
        : "",
      isShow: {
        ticketCard: true, //门票
        travelCard: false, //旅游卡购票
      },
      ticketList: [],
      //景区门票页数、页码、总页数
      page: {
        total: 0,
        page: 1,
        size: 12,
      },
      cardList: [],
      //旅游卡专享页数、页码、总页数
      card_page: {
        total: 0,
        page: 1,
        size: 12,
      },
      rank: {
        "01": "A",
        "02": "AA",
        "03": "AAA",
        "04": "AAAA",
        "05": "AAAAA",
      },
      keyWord: "",
      // total: 0,
      // currentPage: 0,
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        if (!this.fxsId) {
          this.keyWord = to.query.keyWord;
          this.init_yk();
        }
      },
      immediate: true,
    },
  },
  async created() {
    this.$store.commit("setMenuIndex", "2");
    // 是否是分销商登录
    if (this.fxsId) {
      this.init_fx(1);
    } else {
      this.init_yk(1);
    }
  },
  methods: {
    // tab切换--显示门票
    toggle_tick() {
      this.isShow.ticketCard = true;
      this.isShow.travelCard = false;
    },
    // tab切换--显示旅游卡专享
    toggle_travel() {
      this.isShow.ticketCard = false;
      this.isShow.travelCard = true;
      this.getcard(1);
    },

    /**
     * 景区门票--当前用户是游客
     * 搜索门票
     **/
    async init_yk(page) {
      this.isShowLoading = true;
      this.$store.commit("setMenuIndex", "2");
      let params = {
        url: window.location.hostname,
        page: page,
        pageSize: this.page.size,
      };
      if (this.keyWord) {
        params.scenicname = this.keyWord;
      }
      const res = await this.$api.get2(
        this.lee + "/ec/home/v1/wxTicketSearch",
        params
      );
      this.isShowLoading = false;
      if (!res) {
        return;
      }
      this.ticketList = res.data.ticketList ? res.data.ticketList.items : {};
      this.page.total = res.data.ticketList
        ? res.data.ticketList.totalCount
        : 0;
      // this.page.page = 1;
    },
    /**
     * 景区门票--当前用户是从店铺分销商进来
     **/
    async init_fx(page) {
      this.isShowLoading = true;
      let params = {
        url: window.location.hostname,
        usid: this.fxsId,
        page: page, //1,
        pageSize: this.page.size, //12
      };
      const res = await this.$api.get2(
        `${this.lee}/ec/distributorShop/v1/queryHomeProductListForDistributor`,
        params
      );
      this.isShowLoading = false;
      if (!res) {
        return;
      }
      this.ticketList = res.data.ticketList ? res.data.ticketList.items : {};
      this.page.total = res.data.ticketList
        ? res.data.ticketList.totalCount
        : 0;
    },
    /**
     * 景区门票翻页函数
     **/
    async changePage(num) {
      if (this.fxsId) {
        this.init_fx(num);
      } else {
        this.init_yk(num);
      }
      this.page.page = num;
      window.scrollTo(0, 0);
    },
    /**
     * 旅游卡专享
     **/
    async getcard(page) {
      this.isShowLoading = true;
      let params = {
        access_token: sessionStorage.getItem("name"),
        usid: sessionStorage.getItem("userName"),
        page: page, //1,
        pageSize: this.page.size, //12
      };
      await this.$http
        .get(
          `${this.lee}/tourcard/tourcard/v1/userTravelCardl?${this.QS.stringify(
            params
          )}`
        )
        .then((res) => {
          console.log(res);
          this.isShowLoading = false;
          if (!res.data) {
            return;
          }
          if (
            res.data.code === 400 &&
            res.data.msg === "该用户没有有效的旅游卡！"
          ) {
            const _this = this;
            this.$Modal.confirm({
              title: "温馨提示",
              content: "您还没有有效的旅游卡，无法用旅游卡购票",
              okText: "去购买",
              onOk() {
                _this.$router.push({ name: "TravelCard" });
              },
              onCancel() {},
            });
            return;
          } else if (
            res.data.code === 400 &&
            res.data.msg.indexOf("该用户没有实名制") > -1
          ) {
            const _this = this;
            this.$Modal.confirm({
              title: "温馨提示",
              content: "您还没有实名制，去实名制",
              okText: "实名认证",
              onOk() {
                _this.$router.push({ name: "my-bank-card" });
              },
              onCancel() {},
            });
            return;
          } else if (res.data.code !== 200) {
            this.$Modal.info({
              title: "温馨提示",
              content: res.data.msg,
            });
            return;
          } else if (res.data.code === 200) {
            this.cardList = res.data.data.data;
            // this.ticketList = res.data.ticketList ? res.data.ticketList.items : {};
            // this.page.total = res.data.ticketList ? res.data.ticketList.totalCount : 0;
          }
        });
    },
    /**
     * 立即购买
     * 先判断当前用户是分销商还是游客
     * fxsId--存在表示当前用户是分销商--店铺
     * lgtp--存在表示当前用户是游客  01散客  02 分销商
     **/
    buyNow(id, type) {
      let lgtp = sessionStorage.getItem("lgtp");
      if (this.fxsId) {
        this.$router.push({
          name: "ticketDetailPage",
          params: { id: id },
        });
      } else {
        if (lgtp === "02") {
          this.$router.push({
            name: "distributor-order",
          });
        } else {
          this.$router.push({
            name: "ticketDetailPage",
            params: { id: id },
            query: {
              type: type,
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.ivuRow:before {
  content: "";
  display: table;
  width: 100%;
  height: 80px;
  background: url("../../assets/tick_bg.png") no-repeat center;
  background-size: 60% 100%;
  -moz-background-size: 60% 100%;
  position: absolute;
  bottom: 15px;
}
</style>

<style lang="less">
.img {
  width: 424px;
  height: 237px;
  // background: url("../../../../assets/notravelcardList.png") no-repeat center
  background: url("../../assets/notravelcardList.png") no-repeat center 100%;
  margin: auto;
}
.Word {
  color: #828284;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
}
.fade-tick-leave-active,
.fade-tick-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  // transition: all 0.3s ease;
}
.fade-tick-enter,
.fade-tick-leave-to {
  // transform: translateX(10px);
  opacity: 0;
}
img {
  text-align: left;
}

#ticket {
  background-color: #fff;
  .ticket_wrap {
    width: 1220px;
    margin: 0 auto 101px;
    padding: 48px 0 0 0;
    .tickets {
      overflow: hidden;
      margin-bottom: 32px;
      dl {
        width: 285px;
        float: left;
        margin: 0 10px 32px;
        border-radius: 2px;
        dt {
          height: 160.6px;
          background-color: #ececec;
          position: relative;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            float: left;
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            cursor: pointer;
          }
          p {
            position: absolute;
            width: 100%;
            height: 35px;
            line-height: 35px;
            text-indent: 12px;
            font-size: 16px;
            color: #ffffff;
            text-align: left;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
          }
        }
        dd {
          height: 98px;
          border: 1px solid #ececec;
          border-radius: 2px;
          border-top: 0;
          h3 {
            padding: 12px 0 0 12px;
            font-size: 16px;
            color: #191919;
            letter-spacing: 0.8px;
            // line-height: 24px;
            margin-bottom: 16px;
            text-align: left;
            cursor: pointer;
          }
          p {
            overflow: hidden;
            font-size: 14px;
            color: #ff7f0d;
            padding: 0 12px;
            .sp3 {
              float: left;
              font-size: 12px;
            }
            del {
              color: #999;
              margin-left: 4px;
            }
          }
          button {
            float: right;
            width: 88px;
            outline: none;
            border: 0;
            background: #4b7ff0;
            border-radius: 2px;
            line-height: 32px;
            color: #fff;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
    }
    .clearfix {
      display: block;
      content: " ";
      overflow: hidden;
      clear: both;
    }
    .fenye {
      text-align: center;
      .ivu-page {
        &-item,
        &-prev,
        &-next {
          min-width: 24px;
          height: 24px;
          line-height: 24px;
          border-radius: 0;
          a {
            position: relative;
            top: -1px;
            margin: 0 6px;
          }
        }
        &-prev,
        &-next {
          border: 1px solid #dcdee2;
          padding: 0 2px;
          &:hover {
            border-color: #4e81f0;
            a {
              color: #4e81f0;
            }
          }
        }
        &-item {
          &:hover {
            border-color: #4e81f0;
            a {
              color: #4e81f0;
            }
          }
          &-active {
            background-color: #4e81f0;
            border-color: #4e81f0;
            a {
              color: #ffffff;
            }
            &:hover {
              border-color: #4e81f0;
              a {
                color: #ffffff;
              }
            }
          }
          &-jump-prev,
          &-jump-next {
            &:hover {
              a {
                color: #4e81f0;
              }
            }
          }
        }
        &-disabled {
          &:hover {
            border-color: #dcdee2;
            a {
              color: #ccc;
            }
          }
        }
      }
    }
  }
  // 图片标题
  .title {
    text-align: center;
    height: 90px;
    width: 1200px;
    padding-bottom: 10px;
    margin: 0 auto;
    margin-bottom: 8px;
    border-bottom: 1px solid #ececec;
    // text-align: center;
    // height: 90px;
    // padding-bottom: 10px;
    // margin-bottom: 8px;
    // border-bottom: 1px solid #ececec;
    img {
      height: 86px;
    }
  }
  // 倒三角符号
  .dsj {
    width: 0px;
    height: 0px;
    margin: 0 auto 40px;
    border: 8px solid #4b7ff0;
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-right-color: transparent;
  }
}
@media all and (max-width: 1439px) {
  .ticket_wrap {
    width: 1110px !important;
  }
}
</style>
